import React from 'react'
import { useLoaderData } from 'react-router-dom';
import RelatedSection from '../Partials/RelatedSection';

function BlogPost({ NewsPost }) {

    const data = useLoaderData();

    return (
        <>
            <div className="flex flex-col ml-5 w-[67%] max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow max-md:mt-6 max-md:max-w-full">
                    <div className="flex flex-col p-8 bg-white rounded-2xl border border-solid border-neutral-200 max-md:px-5 max-md:max-w-full">
                        {NewsPost &&
                            <div className={`justify-center self-start px-2.5 py-1 mb-5 text-sm font-medium tracking-normal leading-3 text-center text-yellow-700 uppercase whitespace-nowrap bg-amber-100 rounded-xl border border-yellow-700 border-solid`}>
                                إغاثة
                            </div>
                        }
                        <div className={`text-4xl font-bold text-${NewsPost ? 'right' : 'center'} text-zinc-900`}>
                            فيضانات ليبيا مأساة تتطلب تدخلاً إنسانيًا عاجلاً
                        </div>
                        <div className={`flex justify-${NewsPost ? 'right' : 'center px-16'} items-center mt-3 max-md:px-5 max-md:max-w-full`}>
                            <div className={`flex ${NewsPost && 'flex-col-reverse'}  gap-5 justify-between`}>
                                <div className={`flex gap-5 justify-${NewsPost ? 'start' : 'end'} items-center`}>
                                    <img
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/bc436630f3c1c9773decef1989be883a400a61ccdc4d425e0a90aff532bc317b?"
                                        className="self-stretch w-6 aspect-square"
                                    />
                                    <img
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/9b7ebd3e00fb5c13a733e4bf5dd110492544bec87ade50de51e961e62ed6b87b?"
                                        className="self-stretch my-auto w-5 aspect-square"
                                    />
                                    <img
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/8f67c8863c2a897a25d8751afbc410a624d26c878b1eec5e985690999b538a15?"
                                        className="self-stretch my-auto aspect-[1.25] w-[25px]"
                                    />
                                </div>
                                <div className="flex-auto text-base text-center text-zinc-900">
                                    تاريخ النشر: 18 سبتمبر 2023
                                </div>
                            </div>
                        </div>
                        <img
                            loading="lazy"
                            srcSet="https://s3-alpha-sig.figma.com/img/d69f/5982/cc0d17f4cc39b4430ddeccf6537eb31a?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=HlFBkJYWdou~eIRpUQiuRZImUZJuDXWgmZdyRUXp9P2DBWmgV3FPQgnO~uY8YV7Xji1XWUEAXn05qaWA3d2K7fPr7xNdOIOHk8tIKrTJ2LkTQbUNtSTE~N4ZKGO8ghnE~dI1l3oXQfhmEgbU9VRtX3nxryvY8srNHXDM9UIj~saSsMSBNjwX0-RIhB1Aw8nTGwoMxFQNLz-qezVhMlpVcFh3bLFbRDC-9FfdC8BHHoKtnqB-2-yGqiWonGBOMYk9ttnklRM6cH5Q77uIttLwK6zx2t2cw8tH~O70xDDQr8zzy-ZDGeAmi9bx0LGRJL-oaLXRZku0Waou5GbTsom7gQ__"
                            className="mt-8 w-full aspect-[1.82] max-md:max-w-full"
                        />
                        <div className="mt-8 text-base text-right text-zinc-900 max-md:max-w-full">
                            تعيش ليبيا أوقاتًا صعبة بعد تعرضها لفيضانات وأمطار غزيرة
                            نادرة، أسفرت عن خسائر كبيرة وفقدان العديد من الأرواح في مناطق
                            شرق البلاد، ولا سيما في مدينة درنة.
                            <br />
                            ولقى أكثر من 2000 شخص مصرعهم في الكارثة بجانب آلاف المفقودين،
                            حيث تم الإعلان عن حالة الحداد الوطني لمدة 3 أيام، وتنكيس
                            الأعلام تعبيرًا عن الألم الذي يعيشه الشعب الليبي.
                            <br />
                            <br />و تشير التقديرات الأولية إلى وفاة أكثر من 150 شخصًا في
                            مدينة درنة وحدها التي باتت &quot;منكوبة&quot;، ومن المرجح أن
                            يرتفع هذا العدد، بسبب الأمطار الغزيرة التي أسفرت عن تدمير
                            العديد من المباني والبنية التحتية، مما جعل آلاف الأسر تعيش في
                            حالة كارثية.
                            <br />
                            <br />
                            جدير بالذكر أن العاصفة أحدثت دمارا هائلا في البنية التحتية في
                            العديد من المناطق الأخرى، ما تسبب في انقطاع التيار الكهربائي
                            وجرف المنازل والطرق والجسور، كما تعرضت المدارس والمستشفيات
                            لأضرار جسيمة.
                            <br />
                            <br />
                            ومن جانبها تشرع مؤسسة الخير في تنفيذ حملة إغاثة عاجلة لمساعدة
                            المتضررين من الفيضانات في ليبيا، ومن المتوقع أن تقدم المؤسسة
                            المساعدة الإنسانية على شكل مواد غذائية ومياه، ومأوى مؤقت
                            للعائلات المتضررة.
                            <br />
                            <br />
                            تحتاج ليبيا الآن إلى دعم دولي عاجل للتعامل مع هذه الكارثة
                            الإنسانية، لمساعدة الشعب الليبي في هذه اللحظات الصعبة، وضمان
                            توفير المساعدة اللازمة للمتضررين وإعادة إعمار المناطق
                            المتضررة.
                        </div>
                        <div className="mt-8 text-base leading-7 text-right text-zinc-900 max-md:max-w-full">
                            <span className="text-xl font-semibold leading-8">
                                مساعدات
                            </span>
                            <br />
                            وأرسلت منظمات إغاثة دولية مساعدات طارئة، كما قدمت بعض الدول
                            إمدادات ومساعدات أخرى، لكن مكتب تنسيق الشؤون الإنسانية قال إن
                            هناك حاجة إلى المزيد.
                            <br />
                            وتجمع عمال حماية مدنية أرسلتهم الجزائر لتمشيط أنقاض المباني
                            التي كانت ذات يوم متعددة الطوابق بمساعدة الكلاب في محاولة
                            للعثور على أي ناجين.
                            <br />
                            ووزع متطوعون ملابس وأطعمة في مدينة البادية الساحلية التي تقع
                            غربي درنة.
                            <br />
                            <br />
                            وقال محمد شاهين -وهو أحد المشرفين على المبادرة- &quot;ترك
                            الناس منازلهم دون أي شيء، لم يكن لديهم وقت حتى لأخذ
                            ملابس&quot;.
                            <br />
                            وقال متطوع آخر، يدعى عبد النبي، إن الفريق جاء من مدينة
                            العجيلات على بعد نحو 1200 كيلومتر في غرب ليبيا، الذي دخل في
                            صراع متقطع مع الشرق منذ أكثر من عقد. وأضاف &quot;يأتي الناس
                            لمساعدة المتضررين&quot;.
                            <br />
                            وهناك مخاوف من أن يكون آلاف الأشخاص لقوا حتفهم بعد انهيار سدين
                            في مدينة درنة في 10 سبتمبر/أيلول الجاري، مما أدى إلى انهيار
                            مبان سكنية كانت تصطف على جانبي مجرى نهر عادة ما يكون جافا
                            بينما كان الناس نياما.
                            <br />
                            وقد جرفت المياه جثثا كثيرة في اتجاه البحر، وتقول الأمم المتحدة
                            إن أكثر من ألف شخص دفنوا في مقابر جماعية.
                            <br />
                            وجرفت المياه مناطق بأكملها في درنة، التي يقدر عدد سكانها بنحو
                            120 ألف نسمة على الأقل، أو غطتها بالوحل. وأفادت وسائل إعلام
                            رسمية بأن ما لا يقل عن 891 بناية دُمرت في المدينة، فيما قال
                            رئيس البلدية إن 20 ألف شخص ربما يكونون قد لقوا حتفهم جراء هذه
                            الكارثة.
                        </div>
                    </div>
                    <div className="flex flex-col p-8 mt-8 whitespace-nowrap bg-white rounded-2xl border border-solid border-neutral-200 max-md:px-5 max-md:max-w-full">
                        <div className="text-xl font-bold text-right text-zinc-900 max-md:max-w-full">
                            وسوم
                        </div>
                        <div className="flex gap-3 justify-strat self-strat px-px mt-3 text-sm font-medium tracking-normal leading-3 text-center text-black uppercase max-md:flex-wrap max-md:max-w-full">
                            <div className="justify-center px-2.5 py-1 bg-white rounded-xl border-black border-solid aspect-[2.78] border-[0.5px]">
                                المغرب
                            </div>
                            <div className="justify-center px-2.5 py-1 bg-white rounded-xl border-black border-solid aspect-[2.28] border-[0.5px]">
                                ليبيا
                            </div>
                            <div className="justify-center px-2.5 py-1 bg-white rounded-xl border-black border-solid aspect-[2.22] border-[0.5px]">
                                تبرع
                            </div>
                            <div className="justify-center px-2.5 py-1 bg-white rounded-xl border-black border-solid aspect-[3.61] border-[0.5px]">
                                فيضانات
                            </div>
                            <div className="justify-center px-2.5 py-1 bg-white rounded-xl border-black border-solid aspect-[3.06] border-[0.5px]">
                                ملابس
                            </div>
                            <div className="justify-center px-2.5 py-1 bg-white rounded-xl border-black border-solid aspect-[3.39] border-[0.5px]">
                                صدقات
                            </div>
                            <div className="justify-center px-2.5 py-1 bg-white rounded-xl border-black border-solid aspect-[2.44] border-[0.5px]">
                                إغاثة
                            </div>
                        </div>
                    </div>
                    <RelatedSection />
                </div>
            </div>
        </>
    )
}

export default BlogPost